import React, { useState, useEffect, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import Loader from '@components/common/Loader/newLoaderModal';
import cn from 'classnames';
import { LABEL } from '../../../veriables';
import { getObjectValue } from '../../../utility/utills';
import { ReactComponent as Delete } from '@assets/images/delete.svg';
import style from '../serverAppPaymentScreens.module.scss';
import {
    TouchableButton,
    TouchableDiv,
    TouchableImage,
} from '../../common/Touchable/index';
import PaymentOption from './PaymentOption';
import GiftCardList from '../../PaymentScreens/GiftCardList';

const paymentScreenlandscape = props => {
    const {
        seat,
        serverAppTheme,
        setViewDetailsOpen,
        applyAnOfferScreen,
        offerCouponGiftCard,
        giftCardData,
        handleDeleteOffer,
        groupedLoyaltyOffers,
        giftCardScreen,
        onOtherPaymentOptionClick,
        employeeCheckInRef,
        handleOtherPaymentOptions,
        setIsCreditCardPayment,
        toggleOtherPaymentOption,
        couponScreenRouting,
        authInfo,
        creditCardReadyScreen,
        deviceInfo,
        handleGiftCardPayment,
        onDeleteGiftCard,
        isLandScape
    } = props;

    const isLoyaltyLogin = seat?.paymentCheck?.loyalty ? true : false;
    const orderHasLoyaltyOffer = seat.paymentCheck?.offer?.saved;
    const storeInfo = getObjectValue(
        () => JSON.parse(window.sessionStorage.getItem('auth')),
        {}
    );
    const suppressGuestLoyalty = deviceInfo?.deviceGroup?.serverAppSettings?.suppressGuestLoyalty;
    const supportsLoyalty = storeInfo?.loyaltyInfo?.supportsLoyalty;
    const [loyaltyScreen, setloyaltyScreen] = useState({
        offerCouponGiftCard: {
            offer: {
                isCoupon: null,
            },
        },
        giftCardData: null,
    });
    const [couponControl, setCouponControl] = useState(false);
    const [buttonImage, setButtonImage] = useState({
        paymentLoyaltySignInButtonImageUrl: '',
        paymentLoyaltyNoOffersButtonImageUrl: '',
        paymentLoyaltyOffersButtonImageUrl: '',
        paymentCouponButtonImageUrl: '',
        paymentGiftCardButtonImageUrl: '',
        paymentCreditCardButtonImageUrl: '',
    });
    const [isUIReady, setIsUIReady] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    useEffect(() => {
        const themeProperties = JSON.parse(
            window.sessionStorage.getItem('themeProperties')
        );

        setButtonImage({
            paymentLoyaltySignInButtonImageUrl:
                themeProperties?.paymentLoyaltySignInButtonImageUrl,
            paymentLoyaltyNoOffersButtonImageUrl:
                themeProperties?.paymentLoyaltyNoOffersButtonImageUrl,
            paymentLoyaltyOffersButtonImageUrl:
                themeProperties?.paymentLoyaltyOffersButtonImageUrl,
            paymentCouponButtonImageUrl: themeProperties?.paymentCouponButtonImageUrl,
            paymentGiftCardButtonImageUrl:
                themeProperties?.paymentGiftCardButtonImageUrl,
            paymentCreditCardButtonImageUrl:
                themeProperties?.paymentCreditCardButtonImageUrl,
        });

        const timer = setTimeout(() => {
            setIsUIReady(true);
        }, 200);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const isCouponMethods =
            authInfo?.loyaltyInfo?.couponMethods?.includes('qrcode') ||
            authInfo?.loyaltyInfo?.couponMethods?.includes('type') ||
            authInfo?.loyaltyInfo?.couponMethods?.includes('') ||
            authInfo?.loyaltyInfo?.couponMethods === null;
        if (isCouponMethods) setCouponControl(true);
        else setCouponControl(false);
    }, [authInfo]);

    useEffect(() => {
        if (offerCouponGiftCard !== undefined || giftCardData !== undefined) {
            setloyaltyScreen({
                offerCouponGiftCard,
                giftCardData,
            });
            setIsDataLoaded(true);
        }
    }, [offerCouponGiftCard, giftCardData]);

    const otherPaymentOptionCallback = () => {
        handleOtherPaymentOptions(31);
        setIsCreditCardPayment(false);
        toggleOtherPaymentOption();
    };

    useImperativeHandle(employeeCheckInRef, () => {
        return {
            otherPaymentOptionCallback,
        };
    });

    const handleLoyaltySignIn = () => {
        if (seat?.paymentCheck?.loyalty !== null) {

            if (groupedLoyaltyOffers?.OFFERS?.offers?.length <= 0) {
                return LABEL().OS_NO_OFFERS;
            }
            return LABEL().OS_VIEW_OFFERS;
        } else {
            return LABEL().OS_SIGN_IN_TO_LOYALTY;
        }
    }

    const handleLoyaltyImages = () => {
        if (seat?.paymentCheck?.loyalty !== null) {
            if (groupedLoyaltyOffers?.OFFERS?.offers?.length <= 0) {
                return buttonImage?.paymentLoyaltyNoOffersButtonImageUrl;
            }
            return buttonImage?.paymentLoyaltyOffersButtonImageUrl;
        } else {
            return buttonImage?.paymentLoyaltySignInButtonImageUrl;
        }
    }

    const shouldShowLoyaltyButton = () => {
        const deviceGroup = deviceInfo?.deviceGroup;
        const deviceGroupExists = deviceGroup && Object.keys(deviceGroup).length > 0;
        const suppressGuestLoyaltyValue = deviceGroup?.serverAppSettings?.suppressGuestLoyalty;

        if (!deviceGroupExists && supportsLoyalty === true) {
            return true;
        }

        if (!deviceGroupExists && supportsLoyalty === false) {
            return false;
        }

        if (deviceGroupExists && suppressGuestLoyaltyValue === false && supportsLoyalty === true) {
            return true;
        }

        if (deviceGroupExists && suppressGuestLoyaltyValue === false && supportsLoyalty === false) {
            return false;
        }

        if (deviceGroupExists && suppressGuestLoyaltyValue === true) {
            return false;
        }

        return !('supportsLoyalty' in (storeInfo?.loyaltyInfo || {})) && !suppressGuestLoyalty;
    };

    const offerData = ({ offerName, containerClass, deleteBtn, OfferType }) => {
        return (
            <div
                className={cn(
                    'w-100',
                    'd-flex justify-content-between',
                    offerName?.length > 13 ? 'fs-20' : 'fs-30',
                    containerClass
                )}
            >
                <div
                    className={cn(
                        'w-90 text-left fs_16 fw-400',
                        OfferType === 'giftcard' && 'd-flex align-items-center'
                    )}
                    style={{ wordBreak: 'break-word' }}
                >
                    {offerName?.length > 24
                        ? `${offerName?.substring(0, 24)}...`
                        : offerName}
                </div>
                {OfferType === 'giftcard' && (
                    <TouchableDiv
                        className={cn(
                            'w-10 text-right rounded d-flex justify-content-center align-items-center',
                            style.DeletBoxDimension
                        )}
                        style={{
                            border: serverAppTheme?.select_border,
                            backgroundColor: serverAppTheme?.mod_group_name_bg,
                        }}
                        tabIndex="0"
                        role="button"
                        onClick={() => deleteBtn({})}
                    >
                        <Delete
                            width={'60%'}
                            height={'60%'}
                            fill={serverAppTheme?.iconcolor}
                        />
                    </TouchableDiv>
                )}
            </div>
        );
    };
    const formatRedactedCardNumber = (cardNumber) => {
        if (!cardNumber) return "";
        const cardStr = String(cardNumber);
        const lastFour = cardStr.length <= 4 ? cardStr : cardStr.slice(-4);
        return `xxx${lastFour}`;
    };

    const getGiftCardPaymentsFromTickets = () => {
        if (!seat?.paymentCheck?.tickets || seat.paymentCheck.tickets.length === 0) {
            return [];
        }
        return seat.paymentCheck.tickets
            .filter(ticket => ticket.paymentType === 5)
            .map(ticket => ({
                accountNumber: formatRedactedCardNumber(ticket.redactedCardNumber || ticket.cardNumber),
                paymentAmount: ticket.ticketAmount || 0,
                fromTicket: true,
            }));
    };

    const disableGiftCard = () => {
        const supportsLoyalty = storeInfo?.loyaltyInfo?.supportsLoyalty;
        const isCoupon = loyaltyScreen?.offerCouponGiftCard?.offer?.isCoupon;

        return !supportsLoyalty || isCoupon;
    };

    const disableCoupon = () => {
        if (!isDataLoaded) {
            return false;
        }

        const isCoupon = loyaltyScreen?.offerCouponGiftCard?.offer?.isCoupon;
        return isCoupon === false || !couponControl;
    };
    const getCouponButtonStyle = () => {
        if (!isDataLoaded) {
            return {
                background: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
            };
        }

        const shouldDisable = disableCoupon();
        return {
            background: shouldDisable
                ? serverAppTheme?.secondaryBtnDisabled
                : serverAppTheme?.secondaryBtn,
            color: serverAppTheme?.btn_font_color,
        };
    };

    return (
        <>
            {props.loading && <Loader />}
            <div
                className={cn(
                    'h-100 d-flex',
                    props?.showCheckSeat() ? 'pb-1 pt-2' : 'pt-20',
                    seat?.paymentCheck?.paymentAmount <= 0 && 'position-relative'
                )}
            >
                <div className='col-6 pl-0'>
                    <div
                        className={cn(
                            'fs-22 d-flex align-items-center justify-content-center pb-1 fw-600'
                        )}
                        style={{ fontSize: '2rem' }}
                    >
                        {LABEL().OS_DUE}
                    </div>
                    <div className={cn('d-flex align-items-center justify-content-center', props?.showCheckSeat() ? 'h-28' : 'h-34')}>
                        <div
                            style={{
                                // fontSize: '7.125rem',
                                // fontWeight: 300,
                                // fontSize: '7.125rem',
                                fontSize: '5.625rem',
                                fontWeight: 500,
                                lineHeight: 'normal',
                            }}
                        >
                            {LABEL().CURRENCY_SYMBOL}
                            {seat?.paymentCheck?.paymentAmount?.toFixed(2)}
                        </div>
                    </div>
                    <div
                        className={cn(
                            'h-8 fs-22 text-underline d-flex align-items-center justify-content-center fw-600 my-2'
                        )}
                        style={{ fontSize: '1.25rem', color: serverAppTheme?.NO_RECEIPT }}
                    >
                        <TouchableDiv
                            tabIndex="0"
                            role="button"
                            onClick={() => {
                                setViewDetailsOpen(true);
                            }}
                        >
                            {LABEL().OS_ITEMIZED_CHECK}
                        </TouchableDiv>
                    </div>
                    <div
                        className={cn(
                            'text-center px-0 fw-500 my-3',
                            seat?.paymentCheck?.paymentAmount > 0
                                ? 'h-12'
                                : 'h-10 d-flex align-items-end'
                        )}
                    >
                        <span style={{ fontSize: '1rem' }}>
                            {LABEL().OS_CARD_READY ? (
                                LABEL().OS_CARD_READY
                            ) : (
                                <span> {LABEL().OS_CARD_READY} </span>
                            )}{' '}
                        </span>
                    </div>
                    {seat?.paymentCheck?.paymentAmount > 0 && (
                        <TouchableDiv
                            className="fs-20 d-flex justify-content-center align-content-center mb-2"
                            tabIndex="0"
                            role="button"
                            onClick={(e) => {
                                e.preventDefault();
                                isUIReady && onOtherPaymentOptionClick();
                            }}
                        >
                            <a
                                href="#"
                                className="text-underline fw-600 pt-1 text-center fs_20"
                                style={{ color: serverAppTheme?.NO_RECEIPT }}
                            >
                                {LABEL().OS_PAY_WITH_CASH_OR_MULTIPLE_CARDS}
                            </a>
                        </TouchableDiv>
                    )}
                    <div
                        className={cn(
                            'h-12 text-center mt-20',
                            seat?.paymentCheck?.paymentAmount <= 0 &&
                            'position-absolute w-100 d-flex align-items-end'
                        )}
                        style={{ bottom: seat?.paymentCheck?.paymentAmount > 0 ? 0 : '0' }}
                    >
                        <PaymentOption
                            seat={seat}
                            deviceInfo={deviceInfo}
                            handleGiftCardPayment={handleGiftCardPayment}
                            creditCardReadyScreen={creditCardReadyScreen}
                            serverAppTheme={serverAppTheme}
                            buttonImage={buttonImage}
                            isLandScape={isLandScape}
                        />
                    </div>
                </div>
                <div className='col-6 pr-0'>
                    {seat?.control === null || !seat?.control?.partialPayment ? (
                        <div
                        // className={cn(
                        //     LABEL().OS_PAY_WITH_CASH_OR_MULTIPLE_CARDS.length > 31
                        //         ? 'h-46'
                        //         : 'h-50'
                        // )}
                        >
                            <div className="h-100 d-flex flex-column justify-content-start align-items-center w-100">
                                {/* 1. sign into loyalty */}
                                {shouldShowLoyaltyButton() && (
                                    <>
                                        {(seat.paymentCheck?.loyalty &&
                                            (
                                                (seat.paymentCheck?.offer && seat.paymentCheck?.offer?.isCoupon === false) ||
                                                (loyaltyScreen?.offerCouponGiftCard?.offer && loyaltyScreen?.offerCouponGiftCard?.offer?.isCoupon === false)
                                            ))
                                            ? (
                                                <>
                                                    {!orderHasLoyaltyOffer
                                                        &&
                                                        <div
                                                            className={cn('w-100 p-2 mb-2 rounded btn68 d-flex justify-content-center align-items-center', style.btnht)}
                                                            style={{
                                                                backgroundColor:
                                                                    serverAppTheme?.stage_tab_button_selected,
                                                                border: serverAppTheme?.popupBorder,
                                                            }}
                                                        >
                                                            {(loyaltyScreen?.offerCouponGiftCard?.offer?.value?.toFixed(
                                                                2
                                                            ) >= 0 &&
                                                                seat.paymentCheck?.loyalty) ||
                                                                seat.paymentCheck?.offer?.value ? (
                                                                <div
                                                                    className={cn(
                                                                        'w-100 fs_24 fw-400 px-1 d-flex justify-content-between'
                                                                    )}
                                                                >
                                                                    <div className="w-80">
                                                                        {(loyaltyScreen?.offerCouponGiftCard?.offer?.name ||
                                                                            seat?.paymentCheck?.offer?.name)?.length > 24
                                                                            ? (loyaltyScreen?.offerCouponGiftCard?.offer?.name ||
                                                                                seat?.paymentCheck?.offer?.name)?.substring(0, 18) + "..."
                                                                            : (loyaltyScreen?.offerCouponGiftCard?.offer?.name ||
                                                                                seat?.paymentCheck?.offer?.name)
                                                                        }
                                                                    </div>
                                                                    <div className='d-flex justify-content-between'>
                                                                        <div className="w-20 text-right px-3">
                                                                            {LABEL().CURRENCY_SYMBOL}
                                                                            {loyaltyScreen?.offerCouponGiftCard?.offer?.value?.toFixed(
                                                                                2
                                                                            ) || seat.paymentCheck?.offer?.value?.toFixed(2)}
                                                                        </div>
                                                                        {!orderHasLoyaltyOffer && (
                                                                            <TouchableDiv
                                                                                className={cn(
                                                                                    'w-10 text-right rounded d-flex justify-content-center align-items-center',
                                                                                    style.DeletBoxDimension
                                                                                )}
                                                                                style={{
                                                                                    backgroundColor:
                                                                                        serverAppTheme?.mod_group_name_bg,
                                                                                    border: serverAppTheme?.select_border,
                                                                                }}
                                                                                tabIndex="0"
                                                                                role="button"
                                                                                onClick={handleDeleteOffer}
                                                                            >
                                                                                <Delete
                                                                                    width={'60%'}
                                                                                    height={'60%'}
                                                                                    fill={serverAppTheme?.iconcolor}
                                                                                />
                                                                            </TouchableDiv>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ) : null}
                                                        </div>}
                                                </>
                                            ) : (
                                                <>
                                                    {(!isLoyaltyLogin ? (
                                                        buttonImage?.paymentLoyaltySignInButtonImageUrl
                                                            ?.length > 0
                                                    ) : groupedLoyaltyOffers?.OFFERS?.offers?.length <= 0 ? (
                                                        buttonImage?.paymentLoyaltyNoOffersButtonImageUrl
                                                            ?.length > 0
                                                    ) : (
                                                        buttonImage?.paymentLoyaltyOffersButtonImageUrl
                                                            ?.length > 0
                                                    )) ? (
                                                        <TouchableImage
                                                            src={handleLoyaltyImages()}
                                                            className={cn("w-100 mt-1 mb-2", ((seat?.paymentCheck?.loyalty !== null) && (seat?.paymentCheck?.offer?.name || seat?.paymentCheck?.offer?.value !== undefined || (seat?.paymentCheck?.offers?.some(o => o.saved) ?? false))) && 'd-none', style.btnht)}
                                                            style={{ opacity: disableGiftCard() ? '0.2' : '1' }}
                                                            tabIndex="0"
                                                            role="button"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                !disableGiftCard() &&
                                                                    applyAnOfferScreen(!isLoyaltyLogin);
                                                            }}
                                                            alt="paymentLoyaltySignInButtonImageUrl"
                                                        />
                                                    ) : (
                                                        <TouchableButton
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                applyAnOfferScreen(!isLoyaltyLogin);
                                                            }}
                                                            className={cn(
                                                                'rounded btn-ripple my-1 btn68 my-2 w-100', style.btnht,
                                                                !storeInfo?.loyaltyInfo?.supportsLoyalty ||
                                                                    loyaltyScreen?.offerCouponGiftCard?.offer
                                                                        ?.isCoupon
                                                                    ? 'od-disable-btn-bg-color od-disable-btn-font-color'
                                                                    : 'od-primary-btn-bg-color od-primary-btn-font-color',
                                                                ((seat?.paymentCheck?.loyalty !== null) && (seat?.paymentCheck?.offer?.name || seat?.paymentCheck?.offer?.value !== undefined || (seat?.paymentCheck?.offers?.some(o => o.saved) ?? false))) && 'd-none'
                                                            )}
                                                            style={{
                                                                background:
                                                                    !storeInfo?.loyaltyInfo?.supportsLoyalty ||
                                                                        loyaltyScreen?.offerCouponGiftCard?.offer
                                                                            ?.isCoupon
                                                                        ? serverAppTheme?.secondaryBtnDisabled
                                                                        : serverAppTheme?.secondaryBtn,
                                                                color:
                                                                    !storeInfo?.loyaltyInfo?.supportsLoyalty ||
                                                                        loyaltyScreen?.offerCouponGiftCard?.offer
                                                                            ?.isCoupon
                                                                        ? serverAppTheme?.btn_font_color_disabled
                                                                        : serverAppTheme?.btn_font_color,
                                                            }}
                                                            disabled={
                                                                !storeInfo?.loyaltyInfo?.supportsLoyalty ||
                                                                loyaltyScreen?.offerCouponGiftCard?.offer?.isCoupon
                                                            }
                                                            rippleEffect={true}
                                                        >
                                                            <div>
                                                                {handleLoyaltySignIn()}
                                                            </div>
                                                        </TouchableButton>
                                                    )}
                                                </>
                                            )}
                                    </>
                                )}
                                {/* 2. use a coupon */}
                                {loyaltyScreen?.offerCouponGiftCard?.offer?.isCoupon &&
                                    seat.paymentCheck?.offer ? (
                                    <div
                                        className={cn('w-100 my-1 mb-2 rounded')}
                                        style={{
                                            padding: '12px',
                                            color: serverAppTheme?.cancleBtn_font,
                                            backgroundColor: serverAppTheme?.stage_tab_button_selected,
                                            border: serverAppTheme?.offers_Border,
                                        }}
                                    >
                                        {offerData({
                                            offerName: loyaltyScreen?.offerCouponGiftCard?.offer?.name,
                                            offerPrice: loyaltyScreen?.offerCouponGiftCard?.offer?.value?.toFixed(
                                                2
                                            ),
                                            offerButton: 'Delete',
                                            containerClass: '',
                                            deleteBtn: handleDeleteOffer,
                                            OfferType: 'coupon',
                                        })}
                                        {loyaltyScreen?.offerCouponGiftCard?.offer?.value?.toFixed(
                                            2
                                        ) >= 0 && seat.paymentCheck?.offer ? (
                                            <div
                                                className={cn(
                                                    'w-100 fs_24 fw-400 px-1 d-flex justify-content-between align-items-center'
                                                )}
                                            >
                                                {/* <div className="w-20 d-flex align-items-center">{seat.paymentCheck?.offer?.name || LABEL().OS_COUPON}</div> */}
                                                <div className="w-20 d-flex align-items-center">
                                                    {
                                                        seat?.paymentCheck?.offer?.name?.length > 24
                                                            ? seat.paymentCheck.offer.name.substring(0, 18) + "..."
                                                            : seat?.paymentCheck?.offer?.name || LABEL().OS_COUPON
                                                    }
                                                </div>
                                                <div className="w-70 text-right px-3 d-flex align-items-center justify-content-end">
                                                    {LABEL().CURRENCY_SYMBOL}
                                                    {loyaltyScreen?.offerCouponGiftCard?.offer?.value?.toFixed(
                                                        2
                                                    )}
                                                </div>
                                                <div
                                                    className={cn(
                                                        'w-10 px-0 text-right btnBorder d-flex justify-content-center align-items-center',
                                                        style.DeletBoxDimension
                                                    )}
                                                    style={{
                                                        backgroundColor: serverAppTheme?.mod_group_name_bg,
                                                        border: serverAppTheme?.select_border,
                                                    }}
                                                    tabIndex="0"
                                                    role="button"
                                                    onClick={handleDeleteOffer}
                                                >
                                                    <Delete
                                                        width={'60%'}
                                                        height={'60%'}
                                                        fill={serverAppTheme?.iconcolor}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                ) : (
                                    storeInfo?.loyaltyInfo?.supportsCoupon && (
                                        <>
                                            {buttonImage?.paymentCouponButtonImageUrl?.length > 0 ? (
                                                <TouchableImage
                                                    src={buttonImage?.paymentCouponButtonImageUrl}
                                                    className={cn("w-100 mt-1 mb-2", ((seat?.paymentCheck?.loyalty !== null) && (seat?.paymentCheck?.offer?.name || seat?.paymentCheck?.offer?.value !== undefined || (seat?.paymentCheck?.offers?.some(o => o.saved) ?? false))) && 'd-none', style.btnht)}
                                                    style={{ opacity: disableCoupon() ? '0.2' : '1' }}
                                                    tabIndex="0"
                                                    role="button"
                                                    onClick={(event) => {
                                                        event.preventDefault();
                                                        !disableCoupon() && couponScreenRouting('1');
                                                    }}
                                                    alt="paymentCouponButtonImageUrl"
                                                />
                                            ) : (
                                                <TouchableButton
                                                    type="button"
                                                    className={cn(
                                                        'rounded btn-ripple my-1 w-90 btn68 mb-2 w-100', style.btnht,
                                                        disableCoupon() || orderHasLoyaltyOffer
                                                            ? 'od-disable-btn-bg-color od-disable-btn-font-color'
                                                            : 'od-primary-btn-bg-color od-primary-btn-font-color',
                                                        ((seat?.paymentCheck?.loyalty !== null) && (seat?.paymentCheck?.offer?.name || seat?.paymentCheck?.offer?.value !== undefined || (seat?.paymentCheck?.offers?.some(o => o.saved) ?? false))) && 'd-none'
                                                    )}
                                                    disabled={disableCoupon() || orderHasLoyaltyOffer}
                                                    onClick={event => {
                                                        event.preventDefault();
                                                        if (!disableCoupon()) {
                                                            couponScreenRouting();
                                                        }
                                                    }}
                                                    style={getCouponButtonStyle()}
                                                    rippleEffect={true}
                                                >
                                                    <div>{LABEL().OS_USE_A_COUPON}</div>
                                                </TouchableButton>
                                            )}
                                        </>
                                    )
                                )}
                                {/* 3. Add a gift card */}
                                {storeInfo?.loyaltyInfo?.supportsGiftCardPayment && (
                                    <>
                                        {buttonImage?.paymentGiftCardButtonImageUrl?.length >
                                            0 && (
                                                <>
                                                    <TouchableImage
                                                        className={cn('w-100 mt-1 mb-2', style.btnht)}
                                                        src={buttonImage?.paymentGiftCardButtonImageUrl}
                                                        tabIndex="0"
                                                        role="button"
                                                        onClick={event => {
                                                            if (seat?.paymentCheck?.paymentAmount <= 0) {
                                                                return;
                                                            }
                                                            event.preventDefault();
                                                            event.stopPropagation();
                                                            giftCardScreen();
                                                        }}
                                                        alt="paymentGiftCardButtonImageUrl"
                                                        style={{
                                                            opacity: seat?.paymentCheck?.paymentAmount <= 0 ? 0.5 : 1,
                                                            cursor: seat?.paymentCheck?.paymentAmount <= 0 ? 'not-allowed' : 'pointer',
                                                        }}
                                                    />

                                                    {getGiftCardPaymentsFromTickets().length > 0 && (
                                                        <div className="w-100 mb-2">
                                                            <GiftCardList
                                                                giftCards={getGiftCardPaymentsFromTickets()}
                                                                onDeleteCard={(card) => {
                                                                    if (onDeleteGiftCard) {
                                                                        onDeleteGiftCard(card);
                                                                    }
                                                                }}
                                                                serverAppTheme={serverAppTheme}
                                                                currencySymbol={LABEL().CURRENCY_SYMBOL}
                                                                showDelete={false}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        {!buttonImage?.paymentGiftCardButtonImageUrl?.length && (
                                            <>
                                                <TouchableButton
                                                    type="button"
                                                    className={cn(
                                                        'rounded btn-ripple my-1 w-90 btn68 mb-2 w-100 od-primary-btn-bg-color od-primary-btn-font-color', style.btnht
                                                    )}
                                                    style={{
                                                        background: seat?.paymentCheck?.paymentAmount <= 0
                                                            ? (serverAppTheme?.secondaryBtnDisabled || '#d3d3d3')
                                                            : serverAppTheme?.secondaryBtn,
                                                        color: seat?.paymentCheck?.paymentAmount <= 0
                                                            ? (serverAppTheme?.btn_font_color_disabled || '#888')
                                                            : serverAppTheme?.btn_font_color,
                                                        opacity: seat?.paymentCheck?.paymentAmount <= 0 ? 0.5 : 1,
                                                        cursor: seat?.paymentCheck?.paymentAmount <= 0 ? 'not-allowed' : 'pointer',
                                                    }}
                                                    onClick={event => {
                                                        if (seat?.paymentCheck?.paymentAmount <= 0) {
                                                            return;
                                                        }
                                                        event.preventDefault();
                                                        event.stopPropagation();
                                                        giftCardScreen();
                                                    }}
                                                    disabled={seat?.paymentCheck?.paymentAmount <= 0}
                                                    rippleEffect={true}
                                                >
                                                    <div>
                                                        {LABEL().OS_ADD_A_GIFT_CARD}
                                                    </div>
                                                </TouchableButton>

                                                {getGiftCardPaymentsFromTickets().length > 0 && (
                                                    <div className="w-100 my-2">
                                                        <GiftCardList
                                                            giftCards={getGiftCardPaymentsFromTickets()}
                                                            onDeleteCard={(card) => {
                                                                if (onDeleteGiftCard) {
                                                                    onDeleteGiftCard(card);
                                                                }
                                                            }}
                                                            serverAppTheme={serverAppTheme}
                                                            currencySymbol={LABEL().CURRENCY_SYMBOL}
                                                            showDelete={false}
                                                        />
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    ) : (
                        <div
                            className={cn(
                                LABEL().OS_PAY_WITH_CASH_OR_MULTIPLE_CARDS.length > 31
                                    ? 'h-46'
                                    : 'h-50'
                            )}
                        ></div>
                    )}
                </div>
            </div>
        </>
    );
};

const mapStateToProps = ({ loyalty }) => ({
    loading: loyalty.loading,
});

export default connect(mapStateToProps, null)(paymentScreenlandscape);
